import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import { format } from '@/@core/utils/string';
let MailApi = class MailApi {
    constructor(http, urls, miscApi, boHelper) {
        this.http = http;
        this.urls = urls;
        this.miscApi = miscApi;
        this.boHelper = boHelper;
        this.get_mail_source = () => {
            return this.miscApi.getSystemCodes('MAIL_SOURCE');
        };
        this.get_mail_region = () => {
            return this.miscApi.getSystemCodes('MAIL_REGION');
        };
        this.get_mail_created_period = () => {
            return this.miscApi.getSystemCodes('MAIL_CREATED_PERIOD');
        };
        this.get_mail_label = () => {
            return this.miscApi.getSystemCodes('MAIL_LABEL');
        };
        this.get_mail_notification_type = () => {
            return this.miscApi.getSystemCodes('MAIL_RECEIPT_NOTIFICATION_TYPE');
        };
    }
    async getMailSendList(params) {
        params = this.boHelper.maybeSerializeDate(params, 's_created_at_start', 's_created_at_end');
        return this.http.get({
            url: this.urls.get_mail_send_list,
            params,
        });
    }
    async getMailStatus(params) {
        const url = format(this.urls.get_mail_status, params);
        return this.http.get({
            url,
        });
    }
    async postMailResend(emailIds) {
        return this.http.post({
            url: this.urls.postMailResend,
            data: {
                email_ids: emailIds,
            },
        });
    }
    async getMailReceiptsList(params) {
        params = this.boHelper.maybeSerializeDate(params, 's_send_timestamp_start', 's_send_timestamp_end');
        return this.http.get({
            url: this.urls.get_mail_receipts_list,
            params,
        });
    }
    async getMailUnreachableList(params) {
        return this.http.get({
            url: this.urls.get_mailunreachables,
            params,
        });
    }
    async deleteMailUnreachable(params) {
        const url = format(this.urls.delete_mailunreachable, params);
        return this.http.delete({
            url,
        });
    }
    async patchMailUnreachable(params) {
        const url = format(this.urls.patch_mailunreachable, params);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { id, ...payload } = params;
        return this.http.patch({
            url,
            params: payload,
        });
    }
    postMailUnreachable(emails) {
        return this.http.post({
            url: this.urls.postMailUnreachable,
            params: {
                emails,
            },
        });
    }
    async getMailSettingList(params) {
        return this.http.get({
            url: this.urls.get_mail_config_list,
            params: {
                ...params,
                s_mail_type_ids: (params.s_mail_type_ids || []).join(','),
                s_product_ids: (params.s_product_ids || []).join(','),
                s_labels: (params.s_labels || []).join(','),
            },
        });
    }
    createMailSetting(item) {
        return this.http.post({
            url: this.urls.sync_mail_config,
            data: item,
        });
    }
    updateMailSetting(item) {
        return this.http.patch({
            url: this.urls.sync_mail_config,
            data: item,
        });
    }
    updateMailTypeList() {
        return this.http.get({
            url: this.urls.get_mail_type_list,
        });
    }
    createMailType(item) {
        return this.http.post({
            url: this.urls.sync_mail_type,
            data: item,
        });
    }
    updateMailType(item) {
        return this.http.patch({
            url: this.urls.sync_mail_type,
            data: item,
        });
    }
    createMailUnsubReason(item) {
        return this.http.post({
            url: this.urls.sync_mail_unsub_reason,
            data: item,
        });
    }
    updateMailUnsubReason(item) {
        return this.http.patch({
            url: this.urls.sync_mail_unsub_reason,
            data: item,
        });
    }
    getMailUnsubReasons(mail_config_id) {
        if (mail_config_id) {
            return this.http.get({ url: this.urls.getMailConfigReasonMailConfig, params: { mail_config_id } });
        }
        else {
            return this.http.get({ url: this.urls.mail_unsub_reason_list });
        }
    }
    getEntityMailConfig(type, entity_id) {
        if (type === 'USER') {
            return this.http.get({ url: this.urls.user_mail_config, params: { user_id: entity_id } });
        }
        else {
            return this.http.get({ url: this.urls.tenant_mail_config, params: { tenant_id: entity_id } });
        }
    }
    syncEntityMailConfig(type, entity_id, payload) {
        if (type === 'USER') {
            return this.http.post({ url: this.urls.sync_user_mail_config, data: { user_id: entity_id, ...payload } });
        }
        else {
            return this.http.post({ url: this.urls.sync_tenant_mail_config, data: { tenant_id: entity_id, ...payload } });
        }
    }
    getMailLabelOptions() {
        return this.http.get({ url: this.urls.get_mail_label_list });
    }
    getMailConfigProduct(params) {
        return this.http.get({ url: this.urls.getMailConfigProduct, params });
    }
    postMailReasonBatch(params) {
        return this.http.post({
            url: this.urls.postMailReasonBatch,
            data: params,
        });
    }
    postMailTypeBatch(params) {
        return this.http.post({
            url: this.urls.postMailTypeBatch,
            data: params,
        });
    }
};
MailApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.MailApiUrls)),
    __param(2, inject(Symbols.MiscApi)),
    __param(3, inject(Symbols.BoHelperService)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], MailApi);
export { MailApi };
